import { render, staticRenderFns } from "./settingLayout.vue?vue&type=template&id=1b862430&scoped=true"
import script from "./settingLayout.vue?vue&type=script&lang=js"
export * from "./settingLayout.vue?vue&type=script&lang=js"
import style0 from "./settingLayout.vue?vue&type=style&index=0&id=1b862430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b862430",
  null
  
)

export default component.exports